import { useState } from 'react';
import { useSearchAutocomplete } from 'view/hooks/useSearchAutocomplete';
import Autocomplete from 'view/components/Autocomplete';

interface SearchAutocompleteFieldProps<T extends string = string> {
  endpoint: string;
  name: T;
  label?: string;
  value: any;
  setValue: (name: T, value: any) => void;
  getOptionLabel?: (option: any) => string;
  marginbottom?: number;
}

const SearchAutocompleteField = <T extends string = string>({
  endpoint,
  name,
  label = 'Select...',
  value,
  setValue,
  getOptionLabel = (option: any) => {
    return option.name || '';
  },
  marginbottom = 0,
}: SearchAutocompleteFieldProps<T>) => {
  const [inputValue, setInputValue] = useState(() => {
    return value ? getOptionLabel(value) : '';
  });
  const [page, setPage] = useState(1);

  const { data, isLoading } = useSearchAutocomplete(endpoint, inputValue, page);

  return (
    <Autocomplete
      name={name}
      label={label}
      value={value}
      onChange={(val: any) => {
        return setValue(name, val);
      }}
      inputValue={inputValue}
      setInputValue={setInputValue}
      page={page}
      setPage={setPage}
      data={data}
      isLoading={isLoading}
      getOptionLabel={getOptionLabel}
      marginbottom={marginbottom}
    />
  );
};

export default SearchAutocompleteField;
